import { a } from '../global-constants';

const incentives = (state = {}, { type, payload }) => {
	switch (type) {
		case a.SET_INCENTIVES: {
			return payload;
		}
		default:
			return state;
	}
};

export default incentives;
